<template>
  <div>
    <logged-in-header />
    <totem-journeys-panel />
  </div>
</template>

<script>
import loggedInHeader from "../components/common/LoggedInHeader";
import totemJourneysPanel from "../components/totem-journeys/TotemJourneysPanel";

export default {
  components: {
    loggedInHeader,
    totemJourneysPanel
  }
};
</script>
